import { IAccountState } from '../models/IAccountState';

/**
 * The initial state of the account area.
 */
export const accountInitialState: IAccountState = {
  isSsprConvergenceEnabled: {
    isLoading: true,
    isEnabled: false,
  },
  isConvergedUXV2Enabled: {
    isLoading: true,
    isEnabled: false,
  },
  navBarData: undefined,
  enabledApps: { isLoading: true, value: {} },
  currentOrgDisplayName: '',
  currentOrgId: '',
  organizations: { isLoading: true, value: [] },
  currentUser: { objectId: '', userPrincipalName: '', displayName: '' },
  hasError: false,
  hasP2License: false,
};
